/**
 * "Max users" of a T-shirt size (revision 7, R7-A): how many users can log in at
 * that size. Informational only, managed in Admin Settings -> Platform Config,
 * shown on the WorkWise size cards and on Review.
 *
 * Node-safe: no imports (the Vite mock layer uses it through utils/workwise).
 */

/** The backend's lower bound for max_users. */
export const MAX_USERS_MIN = 1

/** A positive whole number, or null when not set (null, '', 0, a fraction or not a number). */
export function readMaxUsers(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null
  const n = typeof value === 'number' ? value : Number(value)
  return Number.isInteger(n) && n >= MAX_USERS_MIN ? n : null
}

/** "up to 25", or "—" when not set. */
export function formatMaxUsers(value: number | null | undefined): string {
  const n = readMaxUsers(value)
  return n === null ? '—' : `up to ${n.toLocaleString('en-US')}`
}

/**
 * The Admin Settings input as sent to the API: null when left empty, the number
 * when it is a whole number of at least 1, otherwise an error to show (the
 * value is then not saved).
 */
export function parseMaxUsersInput(input: unknown): { value: number | null; error: string | null } {
  const text = input === null || input === undefined ? '' : String(input).trim()
  if (text === '') return { value: null, error: null }
  const n = Number(text)
  if (!Number.isInteger(n) || n < MAX_USERS_MIN) {
    return { value: null, error: `Enter a whole number of at least ${MAX_USERS_MIN}, or leave it empty.` }
  }
  return { value: n, error: null }
}
